<template>
  <div
    class="cal-day curr-month"
    :class="{ 'prev-day': dayIsPast, 'today-day': dayIsToday, 'future-day': dayIsFuture }"
    
  >
      <div class="day-number">{{ day.day }}</div>
      <div class="hours-container" v-if="!dayIsPast">
        <div v-for="opSchedule in operatingDay.operatingSchedules" :key="opSchedule.extCalendarId" class="mb-1">
          <span v-if="opSchedule.isClosed" class="text-muted">
            <div class="day-park">{{ resolvePark(opSchedule.extCalendarId).displayName }}</div>
            <div class="day-hours" v-if="opSchedule.isClosed">{{ resolvePark(opSchedule.extCalendarId).closedText }}</div>
            <div class="day-hours" v-else-if="opSchedule.closedToPublic">{{ resolvePark(opSchedule.extCalendarId).closedToPublicText }}</div>
            <div class="day-hours" v-else-if="opSchedule.isAllDay">{{ resolvePark(opSchedule.extCalendarId).allDayText }}</div>
            <div class="day-hours" v-else-if="opSchedule.isTbd">{{ resolvePark(opSchedule.extCalendarId).tbdText }}</div>
            <div class="day-hours" v-else>{{ opSchedule.from }} &mdash; {{ opSchedule.to }}</div>
          </span>
          <span v-if="!opSchedule.isClosed" >
            <a @click="navToDetail">{{ resolvePark(opSchedule.extCalendarId).displayName }} <i class="fa fa-chevron-right"></i></a>
            <div class="day-hours" v-if="opSchedule.closedToPublic">{{ resolvePark(opSchedule.extCalendarId).closedToPublicText }}</div>
            <div class="day-hours" v-else-if="opSchedule.isAllDay">{{ resolvePark(opSchedule.extCalendarId).allDayText }}</div>
            <div class="day-hours" v-else-if="opSchedule.isTbd">{{ resolvePark(opSchedule.extCalendarId).tbdText }}</div>
            <div class="day-hours" v-else>{{ opSchedule.from }} &mdash; {{ opSchedule.to }}</div>
          </span>          
        </div>
      </div>  
      <div class="purchase-container mt-3 mb-3 mr-1">
            <div v-if="operatingDay.operatingSchedules[0] && !operatingDay.operatingSchedules[0].isClosed && !operatingDay.operatingSchedules[0].isTbd">
              <a v-if="purchaseCTAName" :href="purchaseCTAName" style="float: right;"><i class="fas fa-ticket-alt"></i></a>
            </div>
      </div>    
      <div class="featured-container" v-if="!dayIsPast">
          <div v-for="featSchedule in operatingDay.featuredSchedules"
            :key="featSchedule.extCalendarId"
          >
            <div class="featured" :style="{background: resolveActivity(featSchedule.extCalendarId).featuredColor} ">
                <div v-if="resolveActivity(featSchedule.extCalendarId).featuredTextDark" class="darkText">
                  <a :href="resolveActivity(featSchedule.extCalendarId).activityUrl">{{ resolveActivity(featSchedule.extCalendarId).displayName }}</a>
                </div>
                <div v-if="!resolveActivity(featSchedule.extCalendarId).featuredTextDark">
                  <a :href="resolveActivity(featSchedule.extCalendarId).activityUrl">{{ resolveActivity(featSchedule.extCalendarId).displayName }}</a>
                </div>
            </div>    
          </div>
      </div>
    </div>  
</template>

<script lang="ts">
import { defineComponent, toRefs, computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import { DateTime } from 'luxon';
import CalendarAppParam from "../composables/application-parameter";
import * as CalendarModel from '../composables/calendar-model';
import * as ContentModel from '../composables/calendar-content-model';

export default defineComponent({
  props: {
    operatingDay: { type: Object as () => CalendarModel.OperatingDaysResponseDto, required: true }
  },
  setup(props) {
    // Static Properties
    const router = useRouter();
    const contentLookup = inject(ContentModel.ContentLookup)!;
    const resolvePark = (extCalId: string): ContentModel.OperatingContent => contentLookup.value.operatingById[extCalId];
    const resolveActivity = (extCalId: string): ContentModel.CalendarActivityContent => contentLookup.value.activityById[extCalId];
    const appParam = inject(CalendarAppParam)!;

    // Reactive Properties
    const refProps = toRefs(props);
    const day = computed(() => 
      DateTime.fromISO(refProps.operatingDay.value.calendarDate, { zone: appParam.timeZoneName })
    );

    const dayIsPast = computed(() => day.value < DateTime.now().setZone(appParam.timeZoneName).startOf('day'));
    const dayIsToday = computed(() => day.value == DateTime.now().setZone(appParam.timeZoneName).startOf('day'));
    const dayIsFuture = computed(() => day.value > DateTime.now().setZone(appParam.timeZoneName).startOf('day'));
    const navToDetail = () => router.replace({
      name: appParam.listByActivity ? 'DayByActivity' : 'DayByTime',
      params: {
        year: day.value.year,
        month: day.value.month,
        day: day.value.day
      }
    });

    return {
      day,
      dayIsPast,
      dayIsToday,
      dayIsFuture,
      navToDetail,
      resolvePark,
      resolveActivity,
      purchaseCTAName: appParam?.purchaseCTAName,
      purchaseCTAUrl: appParam?.purchaseCTAUrl
    }
  }
});

</script>
